import React, { useState, useRef } from 'react';
import PlacesAutocompleteInput from './PlacesAutocompleteInput';

import Button from '../UI/Button';
import classes from './Forms.module.css';
import icon_info from '../../assets/icons/icon_info.png';
import icon_right from '../../assets/icons/icon_right.png';

import Modal from '../Modals/Modal';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getFestivalLat, getFestivalLng } from '../../config/helpers';

const EditFestival = ( { festival, pressHandler, groupId } ) => {

    const nameRef=useRef();
    const [showForm, setShowForm] = useState(false);
    const [startDate, setStartDate] = useState(festival?.startdate || '');
    const [endDate, setEndDate] = useState(festival?.enddate || '');
    // { label, lat, lng } — for a festival saved before this change, there's
    // no place selection to restore, so seed a label-only value from the
    // plain string that's already stored (lat/lng stay null until
    // re-picked). getFestivalLat/Lng normalise whatever shape the existing
    // coordinates were saved in (plain number or GeoPoint) down to a
    // number, so `location.lat/lng` in this component's own state is
    // always a plain number, never a GeoPoint.
    const [location, setLocation] = useState(() =>
      festival?.location
        ? { label: festival.location, lat: getFestivalLat(festival), lng: getFestivalLng(festival) }
        : null
    );

    const cancelSaveHandler =  () => {
        setShowForm (false);
      };

    const toggleForm = () => {
      setShowForm (!showForm);
      };

    // Selecting a start date always snaps the end date to match it — the
    // user can still move the end date later, but it can never start out
    // (or be dragged back to) earlier than the start date, since the input's
    // own `min` follows startDate too.
    const handleStartDateChange = (event) => {
      const newStart = event.target.value;
      setStartDate(newStart);
      setEndDate(newStart);
    };

    const handleEndDateChange = (event) => {
      setEndDate(event.target.value);
    };

    const submitHandler = (event) =>{
      //submit form, prevent default form functionality
      event.preventDefault();
      //form validation
      if (nameRef.current.value === '' || !location?.label || startDate === '' || endDate === '') {
        alert("Please tell us more about where you're going!"); return false;
      }
      //check end date is before start date
      if (new Date(endDate) < new Date(startDate)) {
        alert("Make sure the event ends after it starts!"); return false;
      }
      setShowForm (false);
      const updatedFestival = {
        custom: true,
        name: nameRef.current.value,
        location: location.label,
        ...(location.lat != null && location.lng != null ? { location_lat: location.lat, location_lng: location.lng } : {}),
        startdate: startDate,
        enddate: endDate,
      }
      pressHandler(updatedFestival)
    }

    return (
        <div className={classes.container}>

            {!festival &&
                <button className={classes.createEventLink} onClick={toggleForm}>
                  + Create my own event
                </button>
            }

            {festival && !showForm &&
                <div className={classes.editEventContainer}>
                  <Button className='flex' onClick={toggleForm}>
                    <div className={classes.settings_button}>
                    <div className={classes.settings_buttonIconHolder}>
                      <img src={icon_info}  alt='edit' className={classes.settings_buttonIcon}  />
                    </div>
                    <div className={classes.settings_buttonText}>Edit event</div>
                    <img src={icon_right}  alt='go' className={classes.settings_buttonArrow}  />
                </div>
                </Button>
                </div>
            }

            {showForm &&
              <Modal
              align='top'
              back
              title={festival ? 'Edit event' : 'Create event'}
              confirmLabel={festival ? undefined : 'Create event'}
              onConfirm={submitHandler}
              onCancel={cancelSaveHandler}
              >

                <form id={groupId}>

                    <input
                    className={classes.formInput}
                    id='name'
                    required
                    placeholder='Event Name*'
                    defaultValue={festival?.name}
                    ref={nameRef}
                    />

                    <PlacesAutocompleteInput
                      value={location}
                      onSelect={setLocation}
                      placeholder='Search for a location*'
                    />

                    <div className={classes.dateFieldGroup}>
                      <label htmlFor='startdate' className={classes.dateFieldLabel}>Start date</label>
                      <input
                      id='startdate'
                      className={classes.formInput}
                      type='date'
                      required
                      value={startDate}
                      onChange={handleStartDateChange}
                      />
                    </div>

                    <div className={classes.dateFieldGroup}>
                      <label htmlFor='enddate' className={classes.dateFieldLabel}>End date</label>
                      <input
                      id='enddate'
                      className={classes.formInput}
                      type='date'
                      required
                      min={startDate || undefined}
                      value={endDate}
                      onChange={handleEndDateChange}
                      />
                    </div>

                    <p className={classes.dateHelperText}>You can always update these details later</p>

                </form>

              </Modal>
            }




        </div>
    );

}

export default EditFestival;
